<script setup lang="ts">
import { FacebookIcon } from "assets/data/icons";
const Icon = useIcon();
</script>
<template>
  <Icon :path="FacebookIcon" :size="24" class="w-7" filled />
</template>
